import { useTranslation } from "react-i18next"
import { faUsers, faBullseye } from "@fortawesome/free-solid-svg-icons"
import Modal from "@/components/modal"
import CardContainer from "@/components/card-container"
import CardButton from "@/components/card-button"
import Tooltip from "@/components/tooltip"

interface Props {
  onClose: () => void
  onSelect: (mode: "dynamic" | "fixed") => void
}

export default function RoleScopeChoiceModal({ onClose, onSelect }: Props) {
  const { t } = useTranslation()
  return (
    <Modal title={t("roles_dashboard_scope")} onClose={onClose} isCloseButtonVisible>
      <CardContainer>
        {(["dynamic", "fixed"] as const).map((mode) => (
          <Tooltip key={mode} text={t(`roles_scope_${mode}_help`)} width={280} usePortal>
            <CardButton
              isCta={mode === "dynamic"}
              icon={mode === "dynamic" ? faUsers : faBullseye}
              title={t(`roles_scope_${mode}`)}
              onClick={() => onSelect(mode)}
            />
          </Tooltip>
        ))}
      </CardContainer>
      <p className="grey-t text-center">{t("roles_scope_combination")}</p>
    </Modal>
  )
}
